import Select from "react-select";
import "./DropDown.css";



const DropDown = ({
  CustomOption,
  selectedValue,
  selectOptions,
  handleChange,
  SingleValue,
}) => {
  return (
    <Select
      value={selectedValue}
      options={selectOptions}
      onChange={handleChange}
      className="rangeFilter"
      styles={{
        singleValue: (base) => ({
          ...base,
          display: "flex",
          alignItems: "center",
        }),
      }}
      components={{
        CustomOption,
        SingleValue,
      }}
    />
  );
};

export default DropDown;
